import { render, staticRenderFns } from "./crudQuery.vue?vue&type=template&id=e563a190&"
import script from "./crudQuery.vue?vue&type=script&lang=js&"
export * from "./crudQuery.vue?vue&type=script&lang=js&"
import style0 from "./crudQuery.vue?vue&type=style&index=0&id=e563a190&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports